import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = "mt-1 w-full border-b-2 border-border bg-transparent px-1 py-2.5 text-espresso rounded-none focus:outline-none focus:border-rust";

export default function AdminReset() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState({ next: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.next !== pw.confirm) return toast.error("Passwords do not match.");
    if (pw.next.length < 10) return toast.error("Password must be at least 10 characters.");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/reset-password`, { token, new_password: pw.next });
      localStorage.setItem("wwf_admin_token", res.data.token);
      toast.success("Password reset.", { description: "You're signed in with your new password." });
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="paper-noise bg-background min-h-[70vh] flex items-center">
      <div className="max-w-sm mx-auto px-5 w-full relative z-10" data-testid="admin-reset">
        <span className="h-11 w-11 bg-espresso text-cream flex items-center justify-center"><KeyRound size={20} /></span>
        <h1 className="mt-5 font-serif font-black text-3xl text-espresso">Choose a New Password</h1>
        {!token ? (
          <p data-testid="admin-reset-missing" className="mt-3 text-muted-foreground text-sm">
            This reset link is missing its code. <Link to="/admin" className="text-rust underline">Request a new one</Link>.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-5">
            <div>
              <label className="label-font text-[11px] text-espresso/70">New Password</label>
              <input data-testid="admin-reset-new" type="password" required autoComplete="new-password" className={inputCls} value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} />
            </div>
            <div>
              <label className="label-font text-[11px] text-espresso/70">Confirm New Password</label>
              <input data-testid="admin-reset-confirm" type="password" required autoComplete="new-password" className={inputCls} value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} />
            </div>
            <button data-testid="admin-reset-submit" type="submit" disabled={loading} className="w-full label-font text-sm bg-rust text-primary-foreground px-6 py-3.5 border border-espresso flex items-center justify-center gap-2 hard-shadow-sm disabled:opacity-60">
              {loading ? <Loader2 size={16} className="animate-spin" /> : "Set Password & Sign In"}
            </button>
            <p className="text-xs text-muted-foreground">Minimum 10 characters. All other sessions will be signed out.</p>
          </form>
        )}
      </div>
    </section>
  );
}
